import { VaultResponse } from '@/features/vaults/types';

export function calculateTVL(vaultsData?: VaultResponse[] | null): number {
  return (vaultsData || []).reduce((acc, vault) => acc + (vault.tvl_usd ?? 0), 0);
}
